import React, { useState } from 'react';
import { Button } from '../components/UI/Button';
export const HostSalon = () => {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    location: '',
    role: '',
    aboutYou: '',
    inspiration: '',
    attendees: '',
    existingCommunity: '',
    communityDescription: '',
    promotionPlan: '',
    experience: '',
    eventDescription: '',
    engagementPlan: '',
    orientationAvailability: '',
    documentationWillingness: '',
    agreement: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [error, setError] = useState('');
  const handleChange = e => {
    const {
      name,
      value,
      type,
      checked
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };
  const handleSubmit = async e => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    try {
      const response = await fetch('https://formspree.io/f/xnngonyv', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          location: '',
          role: '',
          aboutYou: '',
          inspiration: '',
          attendees: '',
          existingCommunity: '',
          communityDescription: '',
          promotionPlan: '',
          experience: '',
          eventDescription: '',
          engagementPlan: '',
          orientationAvailability: '',
          documentationWillingness: '',
          agreement: ''
        });
        setIsSubmitted(true);
      } else {
        throw new Error('Failed to submit form');
      }
    } catch (err) {
      setError('There was an error submitting your application. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };
  if (isSubmitted) {
    return <div className="pt-20 bg-white min-h-screen" data-id="element-2672">
        <div className="container mx-auto px-4 py-16" data-id="element-2673">
          <div className="max-w-3xl mx-auto" data-id="element-2674">
            <div className="bg-white p-8 rounded-lg border-2 border-gray-300 text-center" data-id="element-2675">
              <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-2676">
                Thank you for applying to host a Networking Salon!
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-2677">
                Your submission has been received, and our team will review it
                carefully. If selected, you'll receive hosting guidelines,
                support resources, and a short orientation session to help you
                plan your event.
              </p>
              <p className="text-gray-700 mb-8" data-id="element-2678">
                Together, we'll keep building spaces where connections turn into
                real opportunities.
              </p>
              <a href="https://wa.link/nc2jpo" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-400 rounded-md bg-gray-100 hover:bg-gray-200 transition-colors" data-id="element-2679">
                <span className="mr-2" data-id="element-2680">💬</span>
                Chat With Us on WhatsApp
              </a>
            </div>
          </div>
        </div>
      </div>;
  }
  return <div className="pt-20 bg-white min-h-screen" data-id="element-2681">
      <section className="relative py-16 border-b border-gray-200" data-id="element-2682">
        <div className="absolute inset-0 z-0" data-id="element-2683">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/veE5AXEU4CEztbBqZpUQcx/coverrs.png" alt="Host a Networking Salon" className="w-full h-full object-cover grayscale" data-id="element-2684" />
          <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-2685"></div>
        </div>
        <div className="container mx-auto px-4 relative z-10" data-id="element-2686">
          <div className="max-w-3xl mx-auto text-center" data-id="element-2687">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6" data-id="element-2688">
              Host a Salon
            </h1>
            <p className="text-xl text-gray-200 mb-8" data-id="element-2689">
              Create meaningful connections in your community
            </p>
          </div>
        </div>
      </section>
      <section className="py-16" data-id="element-2690">
        <div className="container mx-auto px-4" data-id="element-2691">
          <div className="max-w-3xl mx-auto" data-id="element-2692">
            <div className="bg-white p-6 rounded-lg border-2 border-gray-300" data-id="element-2693">
              <h2 className="text-2xl font-bold text-gray-800 mb-4" data-id="element-2694">
                Host a Networking Salon — Application Form
              </h2>
              <p className="text-gray-700 mb-6" data-id="element-2695">
                We're excited that you'd like to host a Networking Salon!
                Hosting is more than putting people in a room — it's about
                curating meaningful conversations, creating safe spaces for
                connection, and upholding the values of The Networking Salon.
              </p>
              <p className="text-gray-700 mb-6" data-id="element-2696">
                This short form helps us understand your readiness, your
                audience, and how you plan to make your salon special.
              </p>
              {error && <div className="bg-gray-100 border-2 border-gray-400 text-gray-800 p-4 rounded-md mb-6" data-id="element-2697">
                  {error}
                </div>}
              <form onSubmit={handleSubmit} className="space-y-8" data-id="element-2698">
                <div className="space-y-6" data-id="element-2699">
                  <div data-id="element-2700">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-2701">
                      Section 1: Host Information
                    </h3>
                    <div className="space-y-4" data-id="element-2702">
                      <div data-id="element-2703">
                        <label htmlFor="fullName" className="block text-gray-700 font-medium mb-1" data-id="element-2704">
                          Full Name <span className="text-gray-500" data-id="element-2705">*</span>
                        </label>
                        <input type="text" id="fullName" name="fullName" value={formData.fullName} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2706" />
                      </div>
                      <div data-id="element-2707">
                        <label htmlFor="email" className="block text-gray-700 font-medium mb-1" data-id="element-2708">
                          Email Address <span className="text-gray-500" data-id="element-2709">*</span>
                        </label>
                        <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2710" />
                      </div>
                      <div data-id="element-2711">
                        <label htmlFor="phone" className="block text-gray-700 font-medium mb-1" data-id="element-2712">
                          Phone Number (WhatsApp Preferred){' '}
                          <span className="text-gray-500" data-id="element-2713">*</span>
                        </label>
                        <input type="text" id="phone" name="phone" value={formData.phone} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2714" />
                      </div>
                      <div data-id="element-2715">
                        <label htmlFor="location" className="block text-gray-700 font-medium mb-1" data-id="element-2716">
                          City, Country <span className="text-gray-500" data-id="element-2717">*</span>
                        </label>
                        <input type="text" id="location" name="location" value={formData.location} onChange={handleChange} required className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2718" />
                      </div>
                      <div data-id="element-2719">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-2720">
                          What best describes you?{' '}
                          <span className="text-gray-500" data-id="element-2721">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-2722">
                          {['Community Builder', 'Event Organizer', 'Business Owner / Founder', 'Professional / Creative', 'Student / Young Leader', 'Other'].map(option => <div key={option} className="flex items-center" data-id="element-2723">
                              <input type="radio" id={`role-${option}`} name="role" value={option} checked={formData.role === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-2724" />
                              <label htmlFor={`role-${option}`} className="text-gray-700" data-id="element-2725">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-2726">
                        <label htmlFor="aboutYou" className="block text-gray-700 font-medium mb-1" data-id="element-2727">
                          Tell us a bit about yourself{' '}
                          <span className="text-gray-500" data-id="element-2728">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-2729">
                            Include your background, what you do, and what
                            drives your interest in community building.
                          </span>
                        </label>
                        <textarea id="aboutYou" name="aboutYou" value={formData.aboutYou} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2730" />
                      </div>
                    </div>
                  </div>
                  <div data-id="element-2731">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-2732">
                      Section 2: Event Vision & Reach
                    </h3>
                    <div className="space-y-4" data-id="element-2733">
                      <div data-id="element-2734">
                        <label htmlFor="inspiration" className="block text-gray-700 font-medium mb-1" data-id="element-2735">
                          What inspired you to host a Networking Salon?{' '}
                          <span className="text-gray-500" data-id="element-2736">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-2737">
                            We want to understand your motivation — what excites
                            you about this platform?
                          </span>
                        </label>
                        <textarea id="inspiration" name="inspiration" value={formData.inspiration} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2738" />
                      </div>
                      <div data-id="element-2739">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-2740">
                          Estimated Number of Attendees{' '}
                          <span className="text-gray-500" data-id="element-2741">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-2742">
                          {['20–50', '51–100', '101–200', 'More than 200'].map(option => <div key={option} className="flex items-center" data-id="element-2743">
                                <input type="radio" id={`attendees-${option}`} name="attendees" value={option} checked={formData.attendees === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-2744" />
                                <label htmlFor={`attendees-${option}`} className="text-gray-700" data-id="element-2745">
                                  {option}
                                </label>
                              </div>)}
                        </div>
                      </div>
                      <div data-id="element-2746">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-2747">
                          Do you have an existing community or audience you can
                          invite? <span className="text-gray-500" data-id="element-2748">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-2749">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-2750">
                              <input type="radio" id={`existingCommunity-${option}`} name="existingCommunity" value={option} checked={formData.existingCommunity === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-2751" />
                              <label htmlFor={`existingCommunity-${option}`} className="text-gray-700" data-id="element-2752">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.existingCommunity === 'Yes' && <div data-id="element-2753">
                          <label htmlFor="communityDescription" className="block text-gray-700 font-medium mb-1" data-id="element-2754">
                            If yes, please describe your community or network
                            <span className="block text-sm text-gray-500" data-id="element-2755">
                              Who are they? What connects them? How do you
                              normally engage with them?
                            </span>
                          </label>
                          <textarea id="communityDescription" name="communityDescription" value={formData.communityDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2756" />
                        </div>}
                      <div data-id="element-2757">
                        <label htmlFor="promotionPlan" className="block text-gray-700 font-medium mb-1" data-id="element-2758">
                          How will you promote the event to ensure attendance?{' '}
                          <span className="text-gray-500" data-id="element-2759">*</span>
                          <span className="block text-sm text-gray-500" data-id="element-2760">
                            Share your plan — social media, word of mouth,
                            partnerships, campus networks, etc.
                          </span>
                        </label>
                        <textarea id="promotionPlan" name="promotionPlan" value={formData.promotionPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2761" />
                      </div>
                      <div data-id="element-2762">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-2763">
                          Do you have experience organizing or co-hosting
                          events? <span className="text-gray-500" data-id="element-2764">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-2765">
                          {["Yes, I've organized events before", "Not yet, but I'm confident I can handle it"].map(option => <div key={option} className="flex items-center" data-id="element-2766">
                              <input type="radio" id={`experience-${option}`} name="experience" value={option} checked={formData.experience === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-2767" />
                              <label htmlFor={`experience-${option}`} className="text-gray-700" data-id="element-2768">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      {formData.experience === "Yes, I've organized events before" && <div data-id="element-2769">
                          <label htmlFor="eventDescription" className="block text-gray-700 font-medium mb-1" data-id="element-2770">
                            If yes, briefly describe one event you've hosted or
                            contributed to
                          </label>
                          <textarea id="eventDescription" name="eventDescription" value={formData.eventDescription} onChange={handleChange} rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2771" />
                        </div>}
                    </div>
                  </div>
                  <div data-id="element-2772">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-2773">
                      Section 3: Alignment & Commitment
                    </h3>
                    <div className="space-y-4" data-id="element-2774">
                      <div data-id="element-2775">
                        <label htmlFor="engagementPlan" className="block text-gray-700 font-medium mb-1" data-id="element-2776">
                          The Networking Salon is about meaningful connection,
                          not just attendance. How will you ensure your guests
                          engage deeply and not just "show up"?{' '}
                          <span className="text-gray-500" data-id="element-2777">*</span>
                        </label>
                        <textarea id="engagementPlan" name="engagementPlan" value={formData.engagementPlan} onChange={handleChange} required rows={4} className="w-full px-4 py-2 border-2 border-gray-300 rounded-md focus:outline-none focus:border-gray-500" data-id="element-2778" />
                      </div>
                      <div data-id="element-2779">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-2780">
                          Will you be available for a short orientation session
                          before hosting?{' '}
                          <span className="text-gray-500" data-id="element-2781">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-2782">
                          {['Yes, absolutely', "I'll need advance notice", 'Maybe, depending on timing'].map(option => <div key={option} className="flex items-center" data-id="element-2783">
                              <input type="radio" id={`orientationAvailability-${option}`} name="orientationAvailability" value={option} checked={formData.orientationAvailability === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-2784" />
                              <label htmlFor={`orientationAvailability-${option}`} className="text-gray-700" data-id="element-2785">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                      <div data-id="element-2786">
                        <label className="block text-gray-700 font-medium mb-1" data-id="element-2787">
                          Are you willing to document your salon (photos, short
                          recap, highlights) and share them with our team for
                          visibility? <span className="text-gray-500" data-id="element-2788">*</span>
                        </label>
                        <div className="space-y-2" data-id="element-2789">
                          {['Yes', 'No'].map(option => <div key={option} className="flex items-center" data-id="element-2790">
                              <input type="radio" id={`documentationWillingness-${option}`} name="documentationWillingness" value={option} checked={formData.documentationWillingness === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-2791" />
                              <label htmlFor={`documentationWillingness-${option}`} className="text-gray-700" data-id="element-2792">
                                {option}
                              </label>
                            </div>)}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div data-id="element-2793">
                    <h3 className="text-xl font-bold text-gray-800 mb-4 border-b-2 border-gray-200 pb-2" data-id="element-2794">
                      Final Declaration
                    </h3>
                    <div data-id="element-2795">
                      <label className="block text-gray-700 font-medium mb-1" data-id="element-2796">
                        I understand that hosting a Networking Salon means
                        representing the brand's values of collaboration,
                        respect, and authenticity.{' '}
                        <span className="text-gray-500" data-id="element-2797">*</span>
                      </label>
                      <div className="space-y-2" data-id="element-2798">
                        {['Yes, I understand and agree', "I'd like to learn more first"].map(option => <div key={option} className="flex items-center" data-id="element-2799">
                            <input type="radio" id={`agreement-${option}`} name="agreement" value={option} checked={formData.agreement === option} onChange={handleChange} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-2800" />
                            <label htmlFor={`agreement-${option}`} className="text-gray-700" data-id="element-2801">
                              {option}
                            </label>
                          </div>)}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="pt-2" data-id="element-2802">
                  <Button type="submit" disabled={isSubmitting} className="w-full py-3" data-id="element-2803">
                    {isSubmitting ? 'Submitting...' : 'Submit Application'}
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>;
};